import type { Climate } from '@ottd/api';

import { Hint } from '@/components/prototype/hint';
import { climateCaption, climateSrc } from '@/lib/climate';
import { cn } from '@/lib/utils';

/*
 * The legacy game-list climate thumbnail: a 70×48 crop of an OpenTTD map in
 * the game's landscape (temperate / arctic / tropic / toyland). Renders
 * nothing when the snapshot never recorded a climate.
 */

interface ClimateThumbProps {
  climate: Climate | null | undefined;
  /** Rendered width in px (source is 70×48). */
  width?: number;
  className?: string;
}

export function ClimateThumb({ climate, width = 70, className }: ClimateThumbProps) {
  if (climate === null || climate === undefined) return null;
  const caption = climateCaption(climate);
  return (
    <Hint label={caption}>
      <img
        src={climateSrc(climate)}
        alt={caption}
        width={width}
        height={Math.round((width * 48) / 70)}
        className={cn('bevel block shrink-0', className)}
        style={{ imageRendering: 'pixelated' }}
        draggable={false}
      />
    </Hint>
  );
}
